import { inject } from "@angular/core";
import { TransactionStoreService } from "@bitwarden/web-vault/app/services/store/transaction/transaction.store.service";
import { SignalSubscriptionImpl } from "../data-subscription";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { ClassificationView } from "@bitwarden/web-vault/app/models/view/classification/classification.view";

export type ClassificationTableView = ClassificationView & {
  linkedTransactionCount: number;
  rightChevron: boolean;
};

export type TableSource = ClassificationTableView;

export class ClassificationTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  private transactionStore = inject(TransactionStoreService);
  private userStore = inject(UserStoreService);

  get source() {
    const countMap = this.transactionStore.enrichTransaction.classificationCountMap();
    return (this.userStore.classifications.classificationViewsSorted() ?? []).map(
      (classification) =>
        ({
          ...classification,
          linkedTransactionCount: countMap.get(classification.id) ?? 0,
          rightChevron: true,
        }) as ClassificationTableView,
    );
  }
}
